import { Button } from '@chakra-ui/react';
import { getOrCreateSilktideBannerManager } from 'lib/silktide/manager';
import React from 'react';

const FooterCookieButton = () => (
  <Button
    variant="unstyled"
    display="inline-flex"
    fontFamily="ProximaNova"
    fontSize="xs"
    fontWeight="normal"
    color="secondary.lightGrey"
    h="auto"
    minW={0}
    p={0}
    _hover={{ color: 'primary.white' }}
    onClick={async () => {
      const manager = await getOrCreateSilktideBannerManager();
      manager?.toggleModal(true);
    }}
  >
    Cookie Settings
  </Button>
);

export default FooterCookieButton;
